import '../styles/paymarks.css';

/**
 * Знаки по образцу банка-эквайера (письмо ALTA Pay от 21.10.2026, `artifacts/acquiring-docs/alta-2026-10-21`):
 * знаки приёма карт, логотипы ALTA GROUP и Banca Intesa, знаки программ 3-D Secure, в этом порядке,
 * все в цветных вариантах на белом. `scale` — высота знака относительно общей, как в образце.
 * Знаки программ и банков ведут на их страницы. `strip` — одна строка, при нехватке ширины три.
 */
const V = '?v=7';

const ACCEPTED: Mark[] = [
  { src: `/pay/maestro.svg${V}`, alt: 'Maestro' },
  { src: `/pay/mastercard.svg${V}`, alt: 'Mastercard' },
  { src: `/pay/dinacard.svg${V}`, alt: 'DinaCard' },
  { src: `/pay/visa.svg${V}`, alt: 'Visa', scale: 0.76 },
  { src: `/pay/amex.svg${V}`, alt: 'American Express' },
];

const ISSUERS: Mark[] = [
  { src: `/pay/altagroup.svg${V}`, alt: 'ALTA GROUP', scale: 0.92, href: 'https://altapay.rs/' },
  { src: `/pay/banca-intesa.svg${V}`, alt: 'Banca Intesa', href: 'https://www.bancaintesa.rs/' },
];

const PROGRAMS: Mark[] = [
  { src: `/pay/mc-idcheck.svg${V}`, alt: 'Mastercard ID Check', href: 'https://www.mastercard.rs/sr-rs/korisnici/pronadite-karticu.html' },
  { src: `/pay/visa-secure.svg${V}`, alt: 'Visa Secure', scale: 0.88, href: 'https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html' },
  { src: `/pay/amex-safekey.svg${V}`, alt: 'American Express SafeKey', href: 'https://www.americanexpress.com/us/security-center/safekey/' },
  { src: `/pay/dina-secure.svg${V}`, alt: 'DinaCard Secure' },
];

type Mark = { src: string; alt: string; href?: string; scale?: number };

function Group(props: { marks: Mark[]; kind: string }) {
  return (
    <div className={`paymarks-group is-${props.kind}`} role="list">
      {props.marks.map((mark) => {
        const img = (
          <img
            src={mark.src}
            alt={mark.alt}
            loading="lazy"
            style={mark.scale ? { height: `calc(var(--paymark-h) * ${mark.scale})` } : undefined}
          />
        );
        return mark.href ? (
          <a key={mark.alt} role="listitem" className="paymark" href={mark.href} target="_blank" rel="noreferrer">
            {img}
          </a>
        ) : (
          <span key={mark.alt} role="listitem" className="paymark">
            {img}
          </span>
        );
      })}
    </div>
  );
}

export function PayMarks(props: { caption?: string | undefined; strip?: boolean }) {
  return (
    <div className={props.strip ? 'paymarks is-strip' : 'paymarks'}>
      {props.caption && <span className="paymarks-caption">{props.caption}</span>}
      <div className="paymarks-plate">
        <Group marks={ACCEPTED} kind="accepted" />
        <Group marks={ISSUERS} kind="issuers" />
        <Group marks={PROGRAMS} kind="programs" />
      </div>
    </div>
  );
}
